module.exports = __webpack_public_path__ + "static/perfil-bb4be6982afa32948b7834faa9d5a956.png";